<template>
  <div id="app">
    <div v-show="this.$store.state.DLINE_ENVIRONMENT" id="devenvironment_warning" style="position:fixed;z-index:10000;top:0;width:100px;margin-left:-50px;left:50%;background-color:#ffb734;text-align:center;padding:10px;border-radius:0 0 4px 4px;opacity:.5;font-weight:bold;pointer-events:none;">测试环境</div>
    <!-- <keep-alive :include="['GoodsList']">
        <router-view v-if="$route.meta.keepAlive"></router-view>
     </keep-alive>
     <router-view v-if="!$route.meta.keepAlive"></router-view> -->
     <router-view></router-view>
  </div>
</template>

<script>
export default {
  name: 'App',
  data() {
    return {
      
    };
  },
  watch: {
    '$route': {
      handler(to, from){
        //console.log(to);
        //console.log(from);
      },
      immediate: true,//首次进入页面即执行
    },
  },
  methods: {

  }
}
</script>



// WEBPACK FOOTER //
// src/App.vue